export default __webpack_public_path__ + "static/media/feature-address.ed609571.svg";